'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgSlider = void 0;
const swiper_1 = require("swiper");
const modules_1 = require("swiper/modules");
class ImgSlider {
    constructor() {
        const swiper = new swiper_1.default(".bulletImageSlider", {
            modules: [modules_1.Autoplay],
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 8,
            speed: 10000,
            autoplay: {
                delay: 1,
            },
        });
    }
}
exports.ImgSlider = ImgSlider;
exports.default = ImgSlider;
